import styled from 'styled-components';

export const BigPlayButtonStyled = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
`;

export const StyledIconWrap = styled.div`
  position: absolute;
  height: 32px;
  width: 25px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
